export default __webpack_public_path__ + "static/media/mytrees-config.cb8c12ad.png";